<div class="grid-container">
    <span class="spacer"></span>
    <div class="action-buttons">
        <button mat-raised-button color="primary" (click)="addSchool()" aria-label="Add School">
            <mat-icon>add</mat-icon>
            <span>Add School</span>
        </button>
    </div>
</div>

<mat-card class="mat-elevation-z3">
    <div class="search-container" color="primary">
        <app-search-bar #search (searchEvent)="applyFilter($event);" (clearSearchEvent)="clearFilter();"></app-search-bar>

        <button mat-icon-button [matMenuTriggerFor]="menu" color="primary" class="columnsFilter" (click)="$event.stopPropagation()" matTooltip="Show/Hide Columns">
            <mat-icon>filter_list</mat-icon>
        </button>

        <mat-menu #menu="matMenu" xPosition="before">
            <mat-selection-list
                #columnFilter
                (click)="$event.stopPropagation()"
                [(ngModel)]="columnsToDisplay"
            >
                <mat-list-option [class.hidden]="schoolColumns" value="actions" selected>
                    actions
                </mat-list-option>
                <mat-list-option *ngFor="let column of schoolColumns" [value]="column">
                    {{ column }}
                </mat-list-option>
            </mat-selection-list>
        </mat-menu>
    </div>

    <div class="table-wrapper">
        <table #table mat-table [dataSource]="dataSource" [trackBy]="trackBy">
            <!-- Actions Column -->
            <ng-container matColumnDef="actions" sticky>
                <th mat-header-cell *matHeaderCellDef style="width: 50px"></th>
                <td mat-cell *matCellDef="let school">
                    <!-- <button mat-flat-button color="primary">Edit</button> -->
                    <!-- <button mat-flat-button color="accent">Details</button> -->
                    <!-- <button mat-flat-button color="accent" (click)="expandedEvent = expandedEvent === event ? null : event">Details</button> -->
                    <!-- <button mat-flat-button color="warn">Delete</button> -->
                    <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
                        <mat-icon>more_vertical</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" style="width: 150px">
                        <button mat-menu-item (click)="editSchool(school)"><mat-icon color="primary">edit</mat-icon>Edit</button>
                        <button mat-menu-item (click)="viewSchool(school)">
                            <mat-icon color="primary">visibility</mat-icon>View Details
                        </button>
                        <button mat-menu-item (click)="deleteSchool(school)"><mat-icon color="warn">delete</mat-icon>Delete</button>
                    </mat-menu>
                </td>
            </ng-container>

            <!-- Data Columns -->
            <!-- <ng-container [matColumnDef]="column" *ngFor="let column of schoolColumns" [sticky]="isSticky(stickyColumns, column)">
          <th mat-header-cell *matHeaderCellDef style="min-width: 30px"> {{column}} </th>
          <td mat-cell *matCellDef="let school">
            <ng-container [ngSwitch]="typeOf(school[column])">
              <ng-container *ngSwitchCase="'boolean'">
                <mat-checkbox (click)="$event.stopPropagation()" [checked]="school[column]" [aria-label]="column" disabled></mat-checkbox>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ school[column] }}
              </ng-container>
            </ng-container>
          </td>
        </ng-container> -->

            <!-- SchoolName Column -->
            <ng-container matColumnDef="schoolName" sticky>
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">SchoolName</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.schoolName }}
                </td>
            </ng-container>

            <!-- Center Column -->
            <ng-container matColumnDef="center">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Center</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.center }}
                </td>
            </ng-container>

            <!-- Route Column -->
            <ng-container matColumnDef="route">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Route</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.route }}
                </td>
            </ng-container>

            <!-- Phone Column -->
            <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Phone</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.phone }}
                </td>
            </ng-container>

            <!-- Phone Ext. Column -->
            <ng-container matColumnDef="phoneExt">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Phone Ext.</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.phoneExt }}
                </td>
            </ng-container>

            <!-- _5digit Column -->
            <ng-container matColumnDef="_5digit">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">_5digit</th>
                <td mat-cell *matCellDef="let school">
                    {{ school._5digit }}
                </td>
            </ng-container>

            <!-- Fax Column -->
            <ng-container matColumnDef="fax">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Fax</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.fax }}
                </td>
            </ng-container>

            <!-- _5digit2 Column -->
            <ng-container matColumnDef="_5digit2">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">_5digit2</th>
                <td mat-cell *matCellDef="let school">
                    {{ school._5digit2 }}
                </td>
            </ng-container>

            <!-- Grades Column -->
            <ng-container matColumnDef="grades">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Grades</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.grades }}
                </td>
            </ng-container>

            <!-- Area Column -->
            <ng-container matColumnDef="area">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Area</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.area }}
                </td>
            </ng-container>

            <!-- Principal Column -->
            <ng-container matColumnDef="principal">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Principal</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.principal }}
                </td>
            </ng-container>

            <!-- StreetAddress Column -->
            <ng-container matColumnDef="streetAddress">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">StreetAddress</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.streetAddress }}
                </td>
            </ng-container>

            <!-- City Column -->
            <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">City</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.city }}
                </td>
            </ng-container>

            <!-- Zip Column -->
            <ng-container matColumnDef="zip">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Zip</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.zip }}
                </td>
            </ng-container>

            <!-- Doegrade1213 Column -->
            <ng-container matColumnDef="doegrade1213">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Doegrade1213</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.doegrade1213 }}
                </td>
            </ng-container>

            <!-- PK Column -->
            <ng-container matColumnDef="pk">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">PK</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.pk" aria-label="PK" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.pk" disabled />
                </td>
            </ng-container>

            <!-- Elem Column -->
            <ng-container matColumnDef="elem">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Elem</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.elem" aria-label="Elem" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.elem" disabled />
                </td>
            </ng-container>

            <!-- Mid Column -->
            <ng-container matColumnDef="mid">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Mid</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.mid" aria-label="Mid" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.mid" disabled />
                </td>
            </ng-container>

            <!-- Sr Column -->
            <ng-container matColumnDef="sr">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Sr</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.sr" aria-label="Sr" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.sr" disabled />
                </td>
            </ng-container>

            <!-- Tech Column -->
            <ng-container matColumnDef="tech">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Tech</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.tech" aria-label="Tech" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.tech" disabled />
                </td>
            </ng-container>

            <!-- Arts Column -->
            <ng-container matColumnDef="arts">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Arts</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.arts" aria-label="Arts" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.arts" disabled />
                </td>
            </ng-container>

            <!-- Adult Column -->
            <ng-container matColumnDef="adult">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Adult</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.adult" aria-label="Adult" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.adult" disabled />
                </td>
            </ng-container>

            <!-- Ese Column -->
            <ng-container matColumnDef="ese">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Ese</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.ese" aria-label="Ese" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.ese" disabled />
                </td>
            </ng-container>

            <!-- Charter Column -->
            <ng-container matColumnDef="charter">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Charter</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.charter" aria-label="Charter" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.charter" disabled />
                </td>
            </ng-container>

            <!-- Choice Column -->
            <ng-container matColumnDef="choice">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Choice</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.choice" aria-label="Choice" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.choice" disabled />
                </td>
            </ng-container>

            <!-- Magnet Column -->
            <ng-container matColumnDef="magnet">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Magnet</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.magnet" aria-label="Magnet" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.magnet" disabled />
                </td>
            </ng-container>

            <!-- Ib Column -->
            <ng-container matColumnDef="ib">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Ib</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.ib" aria-label="Ib" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.ib" disabled />
                </td>
            </ng-container>

            <!-- Link Column -->
            <ng-container matColumnDef="link">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Link</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.link }}
                </td>
            </ng-container>

            <!-- TwoMaps Column -->
            <ng-container matColumnDef="twoMaps">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">TwoMaps</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.twoMaps" aria-label="TwoMaps" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.twoMaps" disabled />
                </td>
            </ng-container>

            <!-- PrimaryFunc Column -->
            <ng-container matColumnDef="primaryFunc">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">PrimaryFunc</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.primaryFunc }}
                </td>
            </ng-container>

            <!-- Doegrade1112 Column -->
            <ng-container matColumnDef="doegrade1112">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Doegrade1112</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.doegrade1112 }}
                </td>
            </ng-container>

            <!-- EnrollmentPrev Column -->
            <ng-container matColumnDef="enrollmentPrev">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">EnrollmentPrev</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.enrollmentPrev }}
                </td>
            </ng-container>

            <!-- EnrollmentCurrent Column -->
            <ng-container matColumnDef="enrollmentCurrent">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">EnrollmentCurrent</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.enrollmentCurrent }}
                </td>
            </ng-container>

            <!-- Title1 Column -->
            <ng-container matColumnDef="title1">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Title1</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.title1" aria-label="Title1" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.title1" disabled />
                </td>
            </ng-container>

            <!-- Bell1 Column -->
            <ng-container matColumnDef="bell1">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Bell1</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.bell1 }}
                </td>
            </ng-container>

            <!-- Bell2 Column -->
            <ng-container matColumnDef="bell2">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Bell2</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.bell2 }}
                </td>
            </ng-container>

            <!-- Misc1 Column -->
            <ng-container matColumnDef="misc1">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Misc1</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.misc1 }}
                </td>
            </ng-container>

            <!-- GKg Column -->
            <ng-container matColumnDef="gKg">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">GKg</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.gKg" aria-label="GKg" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.gKg" disabled />
                </td>
            </ng-container>

            <!-- G01 Column -->
            <ng-container matColumnDef="g01">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G01</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g01" aria-label="G01" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g01" disabled />
                </td>
            </ng-container>

            <!-- G02 Column -->
            <ng-container matColumnDef="g02">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G02</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g02" aria-label="G02" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g02" disabled />
                </td>
            </ng-container>

            <!-- G03 Column -->
            <ng-container matColumnDef="g03">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G03</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g03" aria-label="G03" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g03" disabled />
                </td>
            </ng-container>

            <!-- G04 Column -->
            <ng-container matColumnDef="g04">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G04</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g04" aria-label="G04" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g04" disabled />
                </td>
            </ng-container>

            <!-- G05 Column -->
            <ng-container matColumnDef="g05">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G05</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g05" aria-label="G05" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g05" disabled />
                </td>
            </ng-container>

            <!-- G06 Column -->
            <ng-container matColumnDef="g06">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G06</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g06" aria-label="G06" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g06" disabled />
                </td>
            </ng-container>

            <!-- G07 Column -->
            <ng-container matColumnDef="g07">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G07</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g07" aria-label="G07" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g07" disabled />
                </td>
            </ng-container>

            <!-- G08 Column -->
            <ng-container matColumnDef="g08">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G08</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g08" aria-label="G08" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g08" disabled />
                </td>
            </ng-container>

            <!-- G09 Column -->
            <ng-container matColumnDef="g09">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G09</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g09" aria-label="G09" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g09" disabled />
                </td>
            </ng-container>

            <!-- G10 Column -->
            <ng-container matColumnDef="g10">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G10</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g10" aria-label="G10" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g10" disabled />
                </td>
            </ng-container>

            <!-- G11 Column -->
            <ng-container matColumnDef="g11">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G11</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g11" aria-label="G11" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g11" disabled />
                </td>
            </ng-container>

            <!-- G12 Column -->
            <ng-container matColumnDef="g12">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G12</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g12" aria-label="G12" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g12" disabled />
                </td>
            </ng-container>

            <!-- G31 Column -->
            <ng-container matColumnDef="g31">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">G31</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.g31" aria-label="G31" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.g31" disabled />
                </td>
            </ng-container>

            <!-- District Column -->
            <ng-container matColumnDef="district">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">District</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.district }}
                </td>
            </ng-container>

            <!-- Programs Column -->
            <ng-container matColumnDef="programs">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Programs</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.programs" aria-label="Programs" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.programs" disabled />
                </td>
            </ng-container>

            <!-- NextYearMap Column -->
            <ng-container matColumnDef="nextYearMap">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">NextYearMap</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.nextYearMap" aria-label="NextYearMap" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.nextYearMap" disabled />
                </td>
            </ng-container>

            <!-- NextYearTwoMap Column -->
            <ng-container matColumnDef="nextYearTwoMap">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">NextYearTwoMap</th>
                <td mat-cell *matCellDef="let school">
                    <!-- <mat-checkbox [checked]="school.nextYearTwoMap" aria-label="NextYearTwoMap" disabled></mat-checkbox> -->
                    <input type="checkbox" [checked]="school.nextYearTwoMap" disabled />
                </td>
            </ng-container>

            <!-- MapAddress Column -->
            <ng-container matColumnDef="mapAddress">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">MapAddress</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.mapAddress }}
                </td>
            </ng-container>

            <!-- SchoolPhotoUrl Column -->
            <ng-container matColumnDef="schoolPhotoUrl">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">SchoolPhotoUrl</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.schoolPhotoUrl }}
                </td>
            </ng-container>

            <!-- Latitude Column -->
            <ng-container matColumnDef="latitude">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Latitude</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.latitude }}
                </td>
            </ng-container>

            <!-- Longitude Column -->
            <ng-container matColumnDef="longitude">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Longitude</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.longitude }}
                </td>
            </ng-container>

            <!-- PrevSchoolName Column -->
            <ng-container matColumnDef="prevSchoolName">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">PrevSchoolName</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.prevSchoolName }}
                </td>
            </ng-container>

            <!-- DoeGrade1314 Column -->
            <ng-container matColumnDef="doegrade1314">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Doegrade1314</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.doegrade1314 }}
                </td>
            </ng-container>

            <!-- Rssfeedlink Column -->
            <ng-container matColumnDef="rssfeedlink">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Rssfeedlink</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.rssfeedlink }}
                </td>
            </ng-container>

            <!-- Doegrade1415 Column -->
            <ng-container matColumnDef="doegrade1415">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Doegrade1415</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.doegrade1415 }}
                </td>
            </ng-container>

            <!-- Doegrade1516 Column -->
            <ng-container matColumnDef="doegrade1516">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Doegrade1516</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.doegrade1516 }}
                </td>
            </ng-container>

            <!-- Doegrade1617 Column -->
            <ng-container matColumnDef="doegrade1617">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Doegrade1617</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.doegrade1617 }}
                </td>
            </ng-container>

            <!-- WebScreenShotUrl Column -->
            <ng-container matColumnDef="webScreenShotUrl">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">WebScreenShotUrl</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.webScreenShotUrl }}
                </td>
            </ng-container>

            <!-- Description Column -->
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Description</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.description }}
                </td>
            </ng-container>

            <!-- Doegrade1718 Column -->
            <ng-container matColumnDef="doegrade1718">
                <th mat-header-cell *matHeaderCellDef style="min-width: 30px">Doegrade1718</th>
                <td mat-cell *matCellDef="let school">
                    {{ school.doegrade1718 }}
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let event" [attr.colspan]="schoolColumns.length">
            <div class="eventDates-container" [@detailExpand]="event == expandedEvent ? 'expanded' : 'collapsed'">
              <app-event-dates [eventDates]="event.eventDates"></app-event-dates>
            </div>
          </td>
        </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay; let even = even" [class.evenRow]="even"></tr>
            <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="eventsDates-row"
          [class.event-row-expanded]="expandedEvent === row"></tr> -->

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="2">
                    No schools matching the filter
                    <span *ngIf="search.value"> "{{ search.value }}"</span>
                </td>
            </tr>
        </table>
        <div *ngIf="isLoading" style="padding: 1em">Loading data...</div>
    </div>
    <!-- <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator> -->
</mat-card>
